<template>
  <mgl-map
    :access-token="accessToken"
    :map-style.sync="mapStyle"
    :center.sync="center"
    :zoom="zoom"
    @load="onMapLoaded"
  >
    <mgl-scale-control></mgl-scale-control>
    <mgl-navigation-control postion="top-right"></mgl-navigation-control>
    <mgl-fullscreen-control position="top-right"></mgl-fullscreen-control>
    <mgl-geojson-layer
      source-id="`zipcodes.${borders}`"
      :source="zipcodes"
      layer-id="fills"
      :layer="fillsLayer"
    ></mgl-geojson-layer>
    <mgl-geojson-layer
      source-id="`zipcodes.${borders}`"
      :source.sync="zipcodes"
      layer-id="borders"
      :layer="bordersLayer"
    ></mgl-geojson-layer>
    <mgl-geojson-layer
      source-id="`points.${points}`"
      :source="points"
      layer-id="points"
      :layer="pointsLayer"
    ></mgl-geojson-layer>
    <mgl-marker
      v-for="(listing, i) in this.listings"
      :key="i"
      anchor="bottom"
      :offset="markerOffset"
      :color="listing.mls.status === 'Active' ? '#2e7d32' : '#f57f17'"
      :coordinates="[listing.geo.lng, listing.geo.lat]"
    >
      <div
        slot="marker"
        :class="
          listing.mls.status === 'Active' ? 'bubble-green' : 'bubble-orange'
        "
      >
        <template v-if="listing">
          <v-btn
            flat
            color="white"
            small
            :to="{ name: 'mls-listing', params: { mlsId: listing.mlsId } }"
            style="margin: 0;"
          >
            {{ listing.listPrice | round | currency('$', 0) }}K
          </v-btn>
        </template>
      </div>
    </mgl-marker>
  </mgl-map>
</template>

<script>
import Mapbox from 'mapbox-gl';
import {
  MglMap,
  MglMarker,
  MglGeojsonLayer,
  MglScaleControl,
  MglNavigationControl,
  MglFullscreenControl,
} from 'vue-mapbox';
import 'mapbox-gl/dist/mapbox-gl.css';
import 'vue-mapbox/dist/vue-mapbox.css';
import { mapMutations, mapGetters } from 'vuex';
import { getMapListings } from '../api/simplyrets';

export default {
  name: 'ListingsMap',
  components: {
    MglMap,
    MglMarker,
    MglGeojsonLayer,
    MglScaleControl,
    MglNavigationControl,
    MglFullscreenControl,
  },
  data() {
    return {
      accessToken: process.env.MIX_MAPBOX_API_TOKEN,
      mapStyle: 'mapbox://styles/mapbox/streets-v11',
      center: [-115.153969, 36.08601],
      zoom: 12,
      markerOffset: [0, -15],
      zipcodes: {
        type: 'geojson',
        data: '/json/zipcodes.min.geojson',
      },
      points: {
        type: 'geojson',
        data: '/json/points.min.geojson',
      },
      fillsLayer: {
        id: 'fills',
        type: 'fill',
        source: '`zipcodes.${borders}`',
        paint: {
          'fill-color': 'rgba(0, 0, 0, 0.1)',
          'fill-opacity': [
            'case',
            ['boolean', ['feature-state', 'hover'], false],
            1,
            0.5,
          ],
        },
      },
      bordersLayer: {
        id: 'borders',
        type: 'line',
        source: '`zipcodes.${borders}`',
        paint: {
          'line-color': 'rgba(0, 0, 0, 1)',
          'line-width': 2,
        },
      },
      pointsLayer: {
        id: 'points',
        type: 'symbol',
        source: '`points.${points}`',
        layout: {
          // 'icon-image': '{icon}-15',
          'text-field': '{title}',
          // 'text-font': ['Open Sans Semibold', 'Arial Unicode MS Bold'],
          'text-offset': [0, 0.6],
          'text-anchor': 'top',
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      listingsError: 'listingsError',
      listings: 'listings',
    }),
  },
  created() {
    this.getMapListings();
    this.mapbox = Mapbox;
  },
  methods: {
    ...mapMutations(['showSnackbar', 'closeSnackbar']),
    onMapLoaded(event) {
      // in component
      this.map = event.map;
      // or just to store if you want have access from other components
      // this.$store.map = event.map

      this.map.on('click', 'fills', (e) => {
        this.map.flyTo({ center: [e.lngLat.lng, e.lngLat.lat], zoom: 14 });
      });

      // this.map.resize()
    },
    getMapListings() {
      if (window.sessionStorage.getItem('listings') === null) {
        this.$store.dispatch('listings');
        getMapListings()
          .then((res) => {
            this.$store.commit('listingsSuccess', res);
            this.listingsSuccess();
          })
          .catch((error) => {
            this.$store.commit('listingsFailed', { error });
            this.listingsFailed();
          });
      } else {
        JSON.parse(window.sessionStorage.getItem('listings'));
      }
    },
    listingsSuccess() {
      this.showSnackbar({
        text: 'Listings loaded successfully!',
        color: 'success',
        timeout: 5000,
      });
    },
    listingsFailed() {
      this.showSnackbar({
        text: 'There was a problem with getting the requested listings!',
        color: 'warning',
        timeout: 5000,
      });
    },
  },
};
</script>

<style scoped>
.bubble-green {
  background: #2e7d32;
  border-radius: 0.4em;
  margin: 1em 0;
  text-align: center;
  color: #ffffff;
}

.bubble-green:after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 0;
  height: 0;
  border: 0.688em solid transparent;
  border-top-color: #2e7d32;
  border-bottom: 0;
  margin-left: -0.687em;
  margin-bottom: -0.687em;
}

.bubble-orange {
  background: #f57f17;
  border-radius: 0.4em;
  margin: 1em 0;
  text-align: center;
  color: #ffffff;
}

.bubble-orange:after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 0;
  height: 0;
  border: 0.688em solid transparent;
  border-top-color: #f57f17;
  border-bottom: 0;
  margin-left: -0.687em;
  margin-bottom: -0.687em;
}
</style>
